module.exports = __webpack_public_path__ + "static/img/head.8f66b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/head.png
// module id = Ah8B
// module chunks = 1